import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useGET_syllabusesQuery } from 'redux/api/syllabusApi'
import SyllabusPresentation from '../syllabus/SyllabusPresentation'

const PopupSyllabus: FC = () => {
  const { t } = useTranslation()

  const { data: syllabus } = useGET_syllabusesQuery({
    page: 1, page_size: 1
  })
  
  return (
      <>{syllabus?.results?.length > 0 && <SyllabusPresentation popup={true} entity={syllabus.results[0]} />}</>
  )
}

export default PopupSyllabus
